import React from "react"
import { navigateTo } from "utils/navigateTo"
import {
  progressBarWrapper,
  progressBarContainer,
  currentStepWrapper,
  allStepsWrapper,
  progressBarLabelWrapper,
  progressBarFrame,
  stepListItem,
  checkboxChecked,
  checkboxUnChecked,
  progressBar,
} from "./ProgressBarV2.css"
import { ListItemChecked } from "../../../ui-shared/icons/ListItem"

interface ProgressBarV2Props {
  currentStep?: number
  allSteps?: number
  stepCounter?: boolean
  label?: string
  stepList?: {
    name: string
    isCompleted: boolean
    link?: string
  }[]
}

const toTwoDigits = (number) =>
  number.toLocaleString("en-GB", { minimumIntegerDigits: 2 })

export const ProgressBarV2: React.FC<ProgressBarV2Props> = ({
  allSteps,
  currentStep,
  label,
  stepCounter = true,
  stepList,
}) => {
  const maxStepsValue = stepList ? stepList.length : allSteps
  const currentStepValue = stepList
    ? stepList.filter(({ isCompleted }) => isCompleted).length
    : currentStep

  if (maxStepsValue && maxStepsValue <= 1) return <></>

  return (
    <div className={progressBarFrame}>
      {label ? (
        <div className={progressBarLabelWrapper}>
          <label>{label}</label>
        </div>
      ) : (
        <></>
      )}
      <div className={progressBarContainer}>
        {stepCounter ? (
          <span className={currentStepWrapper}>
            {toTwoDigits(currentStepValue)}
          </span>
        ) : (
          <></>
        )}
        <>
          <span className={progressBarWrapper}>
            <progress
              className={progressBar}
              value={currentStepValue}
              max={maxStepsValue}
            />
          </span>
        </>
        {stepCounter ? (
          <span className={allStepsWrapper}>{toTwoDigits(maxStepsValue)}</span>
        ) : (
          <></>
        )}
      </div>
      {stepList ? (
        <div>
          {stepList.map(({ name, isCompleted, link }, idx) => {
            const key = `${name}-${idx}`
            return (
              <div
                className={stepListItem}
                key={key}
                role="button"
                tabIndex={0}
                onClick={() => {
                  if (link) navigateTo(link)
                }}
                onKeyUp={() => {
                  // stupid eslint rules
                }}
              >
                <span
                  className={isCompleted ? checkboxChecked : checkboxUnChecked}
                >
                  <ListItemChecked />
                </span>
                <span>{name}</span>
              </div>
            )
          })}
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
